<template>
    <div>
        <b-modal
            id="export-popup"
            ref="modal"
            title="Export By:"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
        >
            <div slot="modal-title">
                <img
                    src="../../assets/images/export.png"
                    style="display: inline"
                />
                Export By:
            </div>
            <b-form
                v-if="this.$route.meta.title === 'Insights | Alerts'"
                @submit.stop.prevent="exportAlert()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12 mb-4">
                        <div>
                            <a-collapse accordion>
                                <a-collapse-panel
                                    key="1"
                                    header="All Alerts"
                                    class="accordion-heading"
                                >
                                </a-collapse-panel>
                                <a-collapse-panel
                                    key="2"
                                    header="Time Period"
                                    class="accordion-heading"
                                >
                                    <div>
                                        <b-form-group>
                                            <b-form-radio-group
                                                v-model="dateType"
                                                :options="optionsForAlerts"
                                                name="radio-inline"
                                                @input="setFilters"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                    <div
                                        v-if="dateType === 'updated'"
                                        class="row"
                                    >
                                        <div class="col-xs-12">
                                            <a-range-picker
                                                :disabled-date="disabledDate"
                                                @change="onChange"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        v-if="dateType === 'created'"
                                        class="row"
                                    >
                                        <div class="col-xs-12">
                                            <a-range-picker
                                                :disabled-date="disabledDate"
                                                @change="onChange"
                                            />
                                        </div>
                                    </div>
                                </a-collapse-panel>
                                <a-collapse-panel
                                    v-if="dateType !== 'updated'"
                                    key="3"
                                    header="Alert Status"
                                    class="accordion-heading"
                                >
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div
                                                class="form-group custom-datepicker"
                                            >
                                                <b-form-checkbox-group
                                                    id="statusCheckboxes"
                                                    v-model="status"
                                                    :options="alertStatus"
                                                    name="checkboxes"
                                                    class="ml-3"
                                                    stacked
                                                ></b-form-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </a-collapse-panel>
                            </a-collapse>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :class="loading ? 'disabled' : ''"
                        btn-label="Download"
                        btn-type="submit"
                        btn-variant="primary"
                    ></base-button>
                    <base-button
                        :disabled="loading"
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
            <b-form
                v-else
                @submit.stop.prevent="exportReport()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12 mb-4">
                        <a-collapse accordion>
                            <a-collapse-panel
                                key="1"
                                header="Report Type"
                                class="accordion-heading"
                            >
                                <b-form-radio-group
                                    v-model="exportType"
                                    :options="form.exportType"
                                    name="export"
                                ></b-form-radio-group>
                            </a-collapse-panel>
                            <a-collapse-panel
                                key="2"
                                header="Time Period"
                                class="accordion-heading"
                            >
                                <div>
                                    <b-form-group>
                                        <b-form-radio-group
                                            v-model="dateType"
                                            :options="optionsForCustomers"
                                            name="radio-inline"
                                            @input="setFilters"
                                        >
                                        </b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <div v-if="dateType === 'updated'" class="row">
                                    <div class="col-xs-12">
                                        <a-range-picker
                                            :disabled-date="disabledDate"
                                            @change="onChange"
                                        />
                                    </div>
                                </div>
                                <div v-if="dateType === 'created'" class="row">
                                    <div class="col-xs-12">
                                        <a-range-picker
                                            :disabled-date="disabledDate"
                                            @change="onChange"
                                        />
                                    </div>
                                </div>
                            </a-collapse-panel>
                            <a-collapse-panel
                                key="3"
                                header="Customer Status"
                                class="accordion-heading"
                            >
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div
                                            class="form-group custom-datepicker"
                                        >
                                            <b-form-checkbox-group
                                                id="statusCheckboxes"
                                                v-model="status"
                                                :options="statusArray"
                                                name="checkboxes"
                                                class="ml-3"
                                                stacked
                                            ></b-form-checkbox-group>
                                        </div>
                                    </div>
                                </div>
                            </a-collapse-panel>
                        </a-collapse>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :class="loading ? 'disabled' : ''"
                        btn-label="Download"
                        btn-type="submit"
                        btn-variant="primary"
                    ></base-button>
                    <base-button
                        :disabled="loading"
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import excelIcon from '@/components/icons/ExcelIcon.vue'
import pdfIcon from '@/components/icons/PdfIcon.vue'
import request from '@/utils/request'
import {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
} from 'vue-simple-accordion'
import 'vue-simple-accordion/dist/vue-simple-accordion.css'
import DatePicker from 'vue2-datepicker'
import checkBoxListing from '@/components/CheckBoxListing.vue'
import 'ant-design-vue/dist/antd.css'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        excelIcon,
        pdfIcon,
        DatePicker,
        checkBoxListing,
        VsaList,
        VsaItem,
        VsaHeading,
        VsaContent,
        VsaIcon,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            startDate: null,
            endDate: null,
            updatedStartedAt: null,
            updatedEndAt: null,
            dateType: '',
            status: [],
            statusArray: [
                { text: 'Rejected', value: 'rejected' },
                { text: 'Pending', value: 'pending' },
                { text: 'Approved', value: 'approved' },
                {
                    text: 'Automatically Approved',
                    value: 'Automatically Approved',
                },
            ],
            alertStatus: [
                { text: 'Remediated', value: 'approved' },
                { text: 'Pending', value: 'pending' },
                { text: 'Locked', value: 'locked' },
            ],
            optionsForAlerts: [
                { text: 'Updated On', value: 'updated' },
                { text: 'Created On', value: 'created' },
            ],
            optionsForCustomers: [
                { text: 'Updated On', value: 'updated' },
                { text: 'Created On', value: 'created' },
            ],
            exportType: 'export-customers',
            form: {
                exportType: [
                    {
                        text: 'Export All Customers Data',
                        value: 'export-customers',
                    },
                    {
                        text: 'Export Namescreening Hits Data',
                        value: 'export-namescreening-hits',
                    },
                ],
            },
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'hidePopup',
            'chartsHeadings',
            'dataSegmentId',
            'hasScopes',
        ]),
    },

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        this.onLoad()
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        disabledDate(current) {
            // Can not select days after today
            return current > this.$moment().endOf('day')
        },
        async exportReport() {
            try {
                let startDate
                let endDate
                let updatedStartedAt
                let updatedEndAt
                if (this.startDate) {
                    startDate = this.$moment(this.startDate).format(
                        'YYYY-MM-DD'
                    )
                } else {
                    startDate = null
                }

                if (this.endDate) {
                    endDate = this.$moment(this.endDate).format('YYYY-MM-DD')
                } else {
                    endDate = null
                }

                if (this.updatedStartedAt) {
                    updatedStartedAt = this.$moment(
                        this.updatedStartedAt
                    ).format('YYYY-MM-DD')
                } else {
                    updatedStartedAt = null
                }

                if (this.updatedEndAt) {
                    updatedEndAt = this.$moment(this.updatedEndAt).format(
                        'YYYY-MM-DD'
                    )
                } else {
                    updatedEndAt = null
                }

                console.log('Start Date', startDate)
                console.log('End Date', endDate)
                console.log('STATUS', this.status)
                console.log('query before', this.query)
                this.query.startDate = startDate
                this.query.endDate = endDate
                this.query.status = this.status
                this.query.updatedStartedAt = updatedStartedAt
                this.query.updatedEndAt = updatedEndAt
                console.log('query afterwards', this.query)
                console.log('check export type', this.exportType)
                let apiUrl = ''
                if (this.exportType === 'export-customers') {
                    apiUrl = 'customers/export'
                } else {
                    apiUrl = 'customers/export-namescreening-hits'
                }
                let { data } = await request.post(apiUrl, null, {
                    params: this.query,
                })

                console.log('data  ' + JSON.stringify(data))

                this.id = data.data.id
                this.onHidden()
                this.$toasted.show(data.message, {
                    type: 'success',
                })
            } catch (error) {
                console.log(error, 'error')
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the page is loaded
         *
         * @return {void}
         */
        onLoad() {
            console.log('ROUTE', this.$route)
        }, // End of onLoad() method
        async exportAlert() {
            try {
                let updatedStartedAt
                let updatedEndAt
                let startDate
                let endDate
                if (this.startDate) {
                    startDate = this.$moment(this.startDate).format(
                        'YYYY-MM-DD'
                    )
                } else {
                    startDate = null
                }

                if (this.endDate) {
                    endDate = this.$moment(this.endDate).format('YYYY-MM-DD')
                } else {
                    endDate = null
                }

                if (this.updatedStartedAt) {
                    updatedStartedAt = this.$moment(
                        this.updatedStartedAt
                    ).format('YYYY-MM-DD')
                } else {
                    updatedStartedAt = null
                }

                if (this.updatedEndAt) {
                    updatedEndAt = this.$moment(this.updatedEndAt).format(
                        'YYYY-MM-DD'
                    )
                } else {
                    updatedEndAt = null
                }
                console.log('Start Date', updatedStartedAt, 'date', startDate)
                console.log('End Date', updatedEndAt, 'date', endDate)
                console.log('STATUS', this.status)
                console.log('query before', this.query)
                this.query.startDate = startDate
                this.query.endDate = endDate
                this.query.updatedStartedAt = updatedStartedAt
                this.query.updatedEndAt = updatedEndAt
                this.query.status = this.status
                console.log('query afterwards', this.query)
                let { data } = await request.post('alerts/export', null, {
                    params: this.query,
                })

                console.log('data  ' + JSON.stringify(data))

                this.id = data.data.id
                this.onHidden()
                this.$toasted.show(data.message, {
                    type: 'success',
                })
            } catch (error) {
                console.log(error, 'error')
            }
        },

        setFilters() {
            console.log('date type', this.dateType)
        },

        onChange(date, dateString) {
            if (this.dateType === 'updated') {
                // console.log("Updated date 1", dateString[0])
                // console.log("Updated date 2", dateString[1])
                this.updatedStartedAt = dateString[0]
                this.updatedEndAt = dateString[1]
            }
            if (this.dateType === 'created') {
                //    console.log("created date 1", dateString[0])
                //     console.log("created date 2", dateString[1])
                this.startDate = dateString[0]
                this.endDate = dateString[1]
            }
        },
    },
}
</script>
